import { render, staticRenderFns } from "./EnterpriseApp.vue?vue&type=template&id=2b5206a7&scoped=true&"
import script from "./EnterpriseApp.vue?vue&type=script&lang=js&"
export * from "./EnterpriseApp.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseApp.vue?vue&type=style&index=0&id=2b5206a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5206a7",
  null
  
)

export default component.exports